import React, { PureComponent } from 'react';
import { Field, reduxForm, Form } from 'redux-form';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import PropTypes from 'prop-types';
import { Alert, Button } from 'reactstrap';
import renderCheckBoxField from '../form/CheckBox';
import {environment} from '../../../containers/environment';
import { useBasicAuth } from '../auth/withBasicAuth';

class LogInForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    i18n: PropTypes.shape({ changeLanguage: PropTypes.func }).isRequired
  };

  constructor(props) {
    super();
    this.state = {
      showPassword: false,
      message: ''
    };

    this.showPassword = this.showPassword.bind(this);
    this.showError = this.showError.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    let lng = localStorage.getItem(environment.LANGUAGE);
    if(lng !== null && lng !== undefined){
      props.i18n.changeLanguage(lng);
    }

    if(useBasicAuth.isRememberMeEnabled()){
      useBasicAuth.loginWithRememberMeToken(false);
    }

    useBasicAuth.clearIntervals(true);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  componentWillMount(){
  }

  showError(msg){
    this.setState({ message: msg });
  }

  handleSubmit(e){
    useBasicAuth.login(e.username, e.password, e.rememberMe, this.showError);    
  }

  render() {
    const {
      handleSubmit, t
    } = this.props;
    const { showPassword, message } = this.state;

    let msg = "";
    if(message !== ''){
      msg = t('forms.login_form.'+message);
    }

    return (
      <div style={{backgroundColor: '#000000'}}>
        <div className="account account--photo2">
          <div className="account__wrapper">
            <div className="account__card">
              <span className="login__logo2" />
              <h4 className="account__subhead subhead__login2">{t('forms.login_form.account__subhead-subhead')}</h4>
              <Form className="form login-form" onSubmit={handleSubmit(this.handleSubmit)}>
              <Alert
                color="danger"
                isOpen={!!msg}
              >
                {msg}
              </Alert>
              <div className="form__form-group">
                <span className="form__form-group-label" style={{color: "#aaaaaa"}}>{t('forms.login_form.email')}</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <AccountOutlineIcon />
                  </div>
                  <Field
                    name="username"
                    component="input"
                    type='text'
                    className="input-without-border-radius"
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label" style={{color: "#aaaaaa"}}>{t('forms.login_form.password')}</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-icon">
                    <KeyVariantIcon />
                  </div>
                  <Field
                    name="password"
                    component="input"
                    type={showPassword ? 'text' : 'password'}
                    className="input-without-border-radius"
                  />
                  <button
                    type="button"
                    className={`form__form-group-button${showPassword ? ' active' : ''}`}
                    onClick={e => this.showPassword(e)}
                  ><EyeIcon />
                  </button>
                  <div className="account__forgot-password-minerblue">
                    <Link to="/reset_password">{t('forms.login_form.Forgot_a_password')}?</Link>
                  </div>
                </div>
              </div>
              <div className="form__form-group">
                <div className="form__form-group form__form-group-field">
                  <Field
                    name={`rememberMe`}
                    component={renderCheckBoxField}
                    label={t('forms.login_form.Remember_me')}
                    color={"minerblue"}
                    colorLabel={"minerblue"}
                  />
                </div>
              </div>
              <div className="account__btns">
                  <Button className="account__btn" submit="true" color="minerblue">{t('forms.login_form.login')}</Button>
              </div>
            </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'login_form', // a unique identifier for this form
})(withTranslation('common')(LogInForm));
